var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29 16.079C29 8.855 23.18 3 16 3S3 8.855 3 16.079C3 22.609 7.753 28.019 13.969 29v-9.14h-3.3v-3.782h3.3v-2.88c0-3.279 1.94-5.09 4.91-5.09 1.421 0 2.91.256 2.91.256v3.219h-1.64c-1.615 0-2.117 1.008-2.117 2.043v2.453h3.605l-.576 3.78h-3.03V29C24.248 28.019 29 22.608 29 16.079"
  })));
};
export default SvgFacebook;